function AssessmentSummaryDetails(props) {

  // Define variables
  const summary = props.summary;
  const strengths = summary.strengths || [];
  const improvements = summary.improvements || [];


  return (
    <div style={{width: '100%', marginTop: '30px'}}>
      <p><strong>Strengths</strong></p>
      <ul class='assess-summay-ul'>
        {strengths.map((strength, index) =>
          <li key={`strength-${index}`}>{strength}</li>
        )}
      </ul>

      <p><strong>Improvements</strong></p>
      <ul class='assess-summay-ul'>
        {improvements.map((improvement, index) =>
          <li key={`improvement-${index}`}>{improvement}</li>
        )}
      </ul>
    </div>
  );
}

export default AssessmentSummaryDetails;